/**
 * Mock data for Reports
 */

import type { ReportCategory } from '../../types/reports';

export const reportCategories: ReportCategory[] = [
  {
    id: 'operations-monitor',
    title: 'Real-Time Operations Monitor',
    description: 'Monitor mission status, marketplace capacity, and bottlenecks in real-time.',
    icon: 'monitor',
    path: '/reports/operations-monitor',
    metric: 'Live Updates',
    metricColor: 'success',
  },
  {
    id: 'overrides',
    title: 'Manual Overrides & Exceptions',
    description: 'View manual override statistics, reason analysis, and detailed override logs.',
    icon: 'override',
    path: '/reports/overrides',
  },
  {
    id: 'marketplace-health',
    title: 'Marketplace Health KPIs',
    description: 'Analyze supply & demand balance, matching efficiency, and fulfillment quality.',
    icon: 'health',
    path: '/reports/marketplace-health',
    metric: 'Healthy',
    metricColor: 'success',
  },
  {
    id: 'ghost-performance',
    title: 'Ghost Performance',
    description: 'Evaluate Ghost mission performance, quality, compliance, earnings, and engagement.',
    icon: 'ghost',
    path: '/reports/ghost-performance',
  },
  {
    id: 'asset-behavior',
    title: 'Asset (Customer) Behavior',
    description: 'Understand customer usage patterns, conversion funnels, and geographic trends.',
    icon: 'asset',
    path: '/reports/asset-behavior',
  },
  {
    id: 'compliance-risk',
    title: 'Compliance, Fraud & Risk',
    description: 'Monitor PI compliance status, mission compliance, and data access logs.',
    icon: 'compliance',
    path: '/reports/compliance-risk',
  },
  {
    id: 'system-health',
    title: 'System Health',
    description: 'Monitor system errors, API performance, and third-party integration status.',
    icon: 'system',
    path: '/reports/system-health',
    metric: 'All Systems Normal',
    metricColor: 'success',
  },
];

